module.exports = __webpack_public_path__ + "static/fonts/355CC9_1_0.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/355CC9_1_0.woff2
// module id = 146
// module chunks = 0